import { useState } from "react";
import { Card } from "react-bootstrap";
import { IoCreateOutline, IoSettingsOutline } from "react-icons/io5";
import PrimarySmallButton from "../../../components/buttons/PrimarySmallButton";
import { useGetBdapQuery } from "../../../features/bdap/bdapApi";
import { formatBdapDollars } from "../../../features/bdap/bdapOptions";
import BdapFormCanvas from "./BdapFormCanvas";

const detailLabelStyle = {
  fontSize: "12px",
  color: "#6c757d",
  marginBottom: "4px",
};

const detailValueStyle = {
  fontSize: "14px",
  fontWeight: 600,
  color: "#212529",
};

const BdapCard = () => {
  const { data } = useGetBdapQuery();
  const [showForm, setShowForm] = useState(false);
  const bdap = data?.data || null;
  const isConfigured = Boolean(bdap?.bdap_id);

  const requestedOn = bdap?.requested_on
    ? new Date(bdap.requested_on).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "—";

  return (
    <>
      <BdapFormCanvas
        show={showForm}
        onHide={() => setShowForm(false)}
        bdap={bdap}
      />
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-start gap-3">
            <div>
              <h4
                className="mb-0"
                style={{
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212529",
                  marginBottom: "8px",
                }}
              >
                BDAP
              </h4>
              <p className="mt-2 mb-0" style={{ fontSize: "14px", color: "#6c757d" }}>
                {isConfigured
                  ? "Guild will fund your gift credits from BDAP or payroll based on these details."
                  : "Configure BDAP so Guild can fund your gift credits through BDAP or payroll."}
              </p>
            </div>
            <PrimarySmallButton
              onClick={() => setShowForm(true)}
              icon={isConfigured ? <IoCreateOutline /> : <IoSettingsOutline />}
            >
              {isConfigured ? "Edit BDAP details" : "Configure"}
            </PrimarySmallButton>
          </div>

          {isConfigured && (
            <div
              className="mt-3 pt-3"
              style={{ borderTop: "1px solid #eef0f2" }}
            >
              <div className="row g-3">
                <div className="col-6 col-md-3">
                  <div style={detailLabelStyle}>LO code</div>
                  <div style={detailValueStyle}>{bdap?.lo_code || "—"}</div>
                </div>
                <div className="col-6 col-md-3">
                  <div style={detailLabelStyle}>Amount</div>
                  <div style={detailValueStyle}>
                    {formatBdapDollars(bdap?.amount)}
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div style={detailLabelStyle}>Recharge minimum</div>
                  <div style={detailValueStyle}>
                    {formatBdapDollars(bdap?.recharge_limit)}
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div style={detailLabelStyle}>Requested on</div>
                  <div style={detailValueStyle}>{requestedOn}</div>
                </div>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default BdapCard;
